import { IdValue } from '../../../shared/models/id-value.model';
import { mapToIdValues } from '../../../shared/utils/id-value.util';

// 'id': (Usually) the Clear 1 enum as a number. Default: Use this for API requests.
// 'value': (Usually) the Clear 1 enum as a string, if enum exists.
// 'name': Display name.

// Clear 1 enum: None.
export const assetGiftTypes: IdValue[] = mapToIdValues(['Select', 'Cash Gift', 'Gift of Equity', 'Grant']);

// Clear 1 enum: None.
export const constructionClosingTypes: IdValue[] = mapToIdValues(['Select', 'One Closing', 'Two Closing']);

// Clear 1 enum: None.
export const depositedStatuses: IdValue[] = mapToIdValues(['Select', 'Deposited', 'Not Deposited']);

// Clear 1 enum: EstateHeld
export enum EstateHeld {
  NotAssigned = 0,
  FeeSimple = 1,
  LeaseHold = 2,
}

// Clear 1 enum lookup: EstateHeld
export const estateTypes: IdValue[] = [
  new IdValue(EstateHeld.NotAssigned, 'NotAssigned', 'Not Assigned'),
  new IdValue(EstateHeld.FeeSimple, 'FeeSimple', 'Fee Simple'),
  new IdValue(EstateHeld.LeaseHold, 'LeaseHold', 'Leasehold'),
];

// Clear 1 enum: None.
export const giftSources: IdValue[] = mapToIdValues([
  'Select',
  'Community Nonprofit',
  'Employer',
  'Federal Agency',
  'Local Agency',
  'Non-Parent Relative',
  'Other',
  'Parent',
  'Relative',
  'Religious Nonprofit',
  'State Agency',
  'Unmarried Partner',
  'Unrelated Friend',
  'Lender',
]);

// Clear 1 enum: None.
export const indianCountryLandTenures: IdValue[] = mapToIdValues([
  'Select',
  'Fee Simple (On a Reservation)',
  'Individual Trust Land (Allotted / Restricted)',
  'Tribal Trust Land (On a Reservation)',
  'Tribal Trust Land (Off Reservation)',
  'Alaska Native Corporation Land',
]);

// Clear 1 enum: LoanPurposeType
export const loanPurposeTypes: IdValue[] = [
  new IdValue(0, 'NotAssigned', 'Select'),
  new IdValue(1, 'Purchase', 'Purchase'),
  new IdValue(2, 'Refinance', 'Refinance'),
  new IdValue(3, 'Construction', 'Construction'),
  new IdValue(4, 'ConstructionPerm', 'Construction Perm'),
  new IdValue(7, 'PurchaseMoneySecond', 'Second - Purchase Money'),
  new IdValue(10, 'RefiSecond', 'Second - Refinance'),
  new IdValue(5, 'Second', 'Second'),
  new IdValue(9, 'PurchaseMoneyThird', 'Third - Purchase Money'),
  new IdValue(11, 'RefiThird', 'Third - Refinance'),
  new IdValue(6, 'Third', 'Third'),
  new IdValue(8, 'Other', 'Other'),
];

// Clear 1 enum: None.
//  Use 'value' for API requests --> Clear 1 uses either '0' (for 'Select') or the display name.
export const mannersOfTitle: IdValue[] = [
  new IdValue(0, '0', 'Select'),
  new IdValue(1, 'Sole Ownership', 'Sole Ownership'),
  new IdValue(2, 'Life Estate', 'Life Estate'),
  new IdValue(3, 'Tenancy in Common', 'Tenancy in Common'),
  new IdValue(4, 'Joint Tenancy with Right of Survivorship', 'Joint Tenancy with Right of Survivorship'),
  new IdValue(5, 'Tenancy by the Entirety', 'Tenancy by the Entirety'),
  new IdValue(6, 'Joint Tenancy', 'Joint Tenancy'),
  new IdValue(7, 'Joint with Right of Survivorship', 'Joint with Right of Survivorship'),
  new IdValue(8, 'Community Property with Right of Survivorship', 'Community Property with Right of Survivorship'),
  new IdValue(9, 'Periodic Tenancy', 'Periodic Tenancy'),
  new IdValue(10, 'Remainderman with Life Estate', 'Remainderman with Life Estate'),
  new IdValue(11, 'Single', 'Single'),
  new IdValue(12, 'Tenancy at Sufferance', 'Tenancy at Sufferance'),
  new IdValue(13, 'Tenancy at Will', 'Tenancy at Will'),
  new IdValue(14, 'Tenancy for Life', 'Tenancy for Life'),
  new IdValue(15, 'Tenancy for Years', 'Tenancy for Years'),
  new IdValue(16, 'Tenancy in Partnership', 'Tenancy in Partnership'),
  new IdValue(17, 'Tenants by the Entirety', 'Tenants by the Entirety'),
  new IdValue(18, 'Tenants in Severalty', 'Tenants in Severalty'),
  new IdValue(19, 'Husband and Wife', 'Husband and Wife'),
  new IdValue(20, 'Wife and Husband', 'Wife and Husband'),
  new IdValue(21, 'A Married Man', 'A Married Man'),
  new IdValue(22, 'A Married Woman', 'A Married Woman'),
  new IdValue(23, 'Sole and Separate', 'Sole and Separate'),
  new IdValue(24, 'A Single Woman', 'A Single Woman'),
  new IdValue(25, 'A Single Man', 'A Single Man'),
];

// Clear 1 enum: OccupancyType
// export const occupancyTypes: IdValue[] = [
//   new IdValue(0, 'NotAssigned', 'Select'),
//   new IdValue(1, 'PrimaryResidence', 'Primary Residence'),
//   new IdValue(2, 'SecondaryResidence', 'Secondary Residence'),
//   new IdValue(3, 'InvestmentProperty', 'Investment Property'),
// ];

// Clear 1 enum: PropertyClass
export const projectClassifications: IdValue[] = [
  new IdValue(0, 'NotAssigned', 'Select'),
  new IdValue(1, 'AIIICondoObsolete', 'A III Condo (obsolete)'),
  new IdValue(2, 'BIIICondoObsolete', 'B II Condo (obsolete)'),
  new IdValue(3, 'CIIICondoObsolete', 'C I Condo (obsolete)'),
  new IdValue(4, 'EPUD', 'E Established PUD Project'),
  new IdValue(5, 'FPUD', 'F New PUD Project'),
  new IdValue(6, 'IIIPUDObsolete', 'III PUD (obsolete)'),
  new IdValue(7, 'FirstCOOP', '1 Full Review - Co-op Project'),
  new IdValue(8, 'SecondCOOP', '2 Fannie Mae Review through PERS - Co-op Project'),
  new IdValue(9, 'FHAVACondoOrSpotLoan', 'FHA_VA Condo Or Spot Loan'),
  new IdValue(10, 'PLimitedReviewNew', 'P Limited Review - New Condo Project'),
  new IdValue(11, 'QLimitedReviewEst', 'Q Limited Review - Established Condo Project'),
  new IdValue(12, 'RExpeditedReviewNew', 'R Full Review - New Condo Project'),
  new IdValue(13, 'SExpeditedReviewEst', 'S Full Review - Established Condo Project'),
  new IdValue(14, 'TFannieMaeReview', 'T Fannie Mae Review through PERS - Condo Project'),
  new IdValue(15, 'UFHAApproved', 'U FHA-approved Condo Project'),
  new IdValue(16, 'StreamlinedReview', 'Streamlined Review'),
  new IdValue(17, 'EstablishedProject', 'Established Project'),
  new IdValue(18, 'NewProject', 'New Project'),
  new IdValue(19, 'DetachedProject', 'Detached Project'),
  new IdValue(20, 'TwoOrFourUnitProject', '2- to 4-unit Project'),
  new IdValue(21, 'ReciprocalReview', 'Reciprocal Review'),
  new IdValue(22, 'VRefiPlusTM', 'V Condo Project Review Waived'),
  new IdValue(23, 'TPUD', 'T PUD (obsolete)'),
  new IdValue(24, 'TCOOP', 'T COOP (obsolete)'),
  new IdValue(25, 'ExemptFromReview', 'Exempt from Review'), // Not in enum.
  new IdValue(999, 'GNotInAProjectOrDevelopment', 'Not in a Project or Development'),
];

export enum ProjectType {
  condominium = 'condominium',
  cooperative = 'cooperative',
  pud = 'pud',
  none = 'none',
}

// Clear 1 enum: None, but values are defined in Clear 1 template.
export const projectTypes: IdValue<string>[] = [
  new IdValue(ProjectType.condominium, ProjectType.condominium, 'Condominium'),
  new IdValue(ProjectType.cooperative, ProjectType.cooperative, 'Cooperative'),
  new IdValue(ProjectType.pud, ProjectType.pud, 'Planned Unit Development (PUD)'),
  new IdValue(ProjectType.none, ProjectType.none, 'Property is not located in a project'),
];

// TODO: Verify if 'Detached' and 'Attached' have correct 'id' values.
// Clear 1 enum: SubjectPropertyType
export const subjectPropertyTypes: IdValue[] = [
  new IdValue(0, 'NotAssigned', 'Select'),
  new IdValue(1, 'Detached', 'Detached'),
  new IdValue(2, 'Attached', 'Attached'),
  new IdValue(3, 'Condominium', 'Condominium'),
  new IdValue(4, 'HighRiseCondo', 'High Rise Condo'),
  new IdValue(5, 'DetachedCondo', 'Detached Condo'),
  new IdValue(6, 'PUD', 'PUD'),
  new IdValue(7, 'Cooperative', 'Cooperative'),
  new IdValue(9, 'ManufacturedCondoPUDCoOp', 'Manufactured Condo/PUD/Co-Op'),
  new IdValue(10, 'ManufacturedSingleWide', 'Manufactured SingleWide'),
  new IdValue(11, 'ManufacturedMultiWide', 'Manufactured MultiWide'),
  new IdValue(14, 'ManufacturedMHAdvantage', 'Manufactured MH Advantage'),
  new IdValue(13, 'VacantLand', 'Vacant Land'),
  new IdValue(12, 'Other', 'Other'),
];

export enum SubjectPropertyType {
  Detached = 1,
  Attached = 2,
  Condominium = 3,
  HighRiseCondo = 4,
  DetachedCondo = 5,
  PUD = 6,
  Cooperative = 7,
  Manufactured = 8,
  ManufacturedCondoPUDCoOp = 9,
  ManufacturedSingleWide = 10,
  ManufacturedMultiWide = 11,
  Other = 12,
  VacantLand = 13,
  ManufacturedMHAdvantage = 14,
}

// Clear 1 enum: None.
export const trustTypes: IdValue[] = mapToIdValues([
  'Select',
  'Irrevocable',
  'Inter Vivos Living Trust',
  'Illinois Land Trust',
  'Other',
  'Other Land Trust',
]);

export enum LandLoanStatus {
  Select = 0,
  LandOwnedFreeAndClear = 1,
  ExistingLandLoanToBeRefinanced = 2,
  LandToBePurchasedWithLoanProceeds = 3,
}

export const landLoanStatusTypes = IdValue.fromEnum(LandLoanStatus);

export enum ConstructionPurpose {
  Select = 0,
  InitialConstruction = 1,
  HomeImprovement = 2,
}

export const constructionPurposeTypes = IdValue.fromEnum(ConstructionPurpose);

export const buyDownType: IdValue[] = [
  new IdValue(0, 'None', 'Select'),
  new IdValue(1, '_5_4_3_2_1', '_5_4_3_2_1'),
  new IdValue(2, '_4_3_2_1', '_4_3_2_1'),
  new IdValue(3, '_3_2_1', '_3_2_1'),
  new IdValue(4, '_2_1', '_2_1'),
  new IdValue(5, '_1_0', '_1_0'),
  new IdValue(6, 'Compressed_5_4_3_2_1', 'Compressed_5_4_3_2_1'),
  new IdValue(7, 'Compressed_4_3_2_1', 'Compressed_4_3_2_1'),
  new IdValue(8, 'Compressed_3_2_1', 'Compressed_3_2_1'),
  new IdValue(9, 'Compressed_2_1', 'Compressed_2_1'),
  new IdValue(10, 'Compressed_1_0', 'Compressed_1_0'),
  new IdValue(11, 'HalfStepFrom5', 'HalfStepFrom5'),
  new IdValue(12, 'HalfStepFrom4', 'HalfStepFrom4'),
  new IdValue(13, 'HalfStepFrom3', 'HalfStepFrom3'),
  new IdValue(14, 'HalfStepFrom2_5', 'HalfStepFrom2_5'),
  new IdValue(15, 'HalfStepFrom2', 'HalfStepFrom2'),
  new IdValue(16, 'HalfStepFrom1_5', 'HalfStepFrom1_5'),
  new IdValue(17, 'HalfStepFrom1', 'HalfStepFrom1'),
  new IdValue(18, 'HalfStepFrom0_5', 'HalfStepFrom0_5'),
];

export const escrowWaiverType: IdValue[] = [
  new IdValue(0, 'NotAssigned', 'Not Assigned'),
  new IdValue(1, 'WaiveAll', 'Waive All'),
  new IdValue(2, 'NotWaived', 'Not Waived'),
  new IdValue(3, 'WaiveTaxesOnly', 'Waive Taxes Only'),
  new IdValue(4, 'WaiveInsuranceOnly', 'Waive Insurance Only'),
];
